import { render } from "./AssignmentResultsComponent.vue?vue&type=template&id=e89b60a6&scoped=true"
import script from "./AssignmentResultsComponent.vue?vue&type=script&lang=js"
export * from "./AssignmentResultsComponent.vue?vue&type=script&lang=js"

import "./AssignmentResultsComponent.vue?vue&type=style&index=0&id=e89b60a6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e89b60a6"]])

export default __exports__